import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Listbox } from "@headlessui/react";
import { Fragment } from "react";
import { HiMiniUserCircle } from "react-icons/hi2";
import BusinessNav from "./BusinessNav";
import AddBusiness from "./AddBusiness";
import BusinessPage from "./BusinessPage";
import EmployeesPage from "./EmployeesPage";
import AddEmployeePage from "./AddEmployeePage";
import StartPayrollPage from "./StartPayrollPage";
import AddPreviousPayrollPage from "./AddPreviousPayrollPage";
import EditEmployeePage from "./EditEmployeePage";
import "./Dashboard.css";
import api from "../services/api";
//import payweekwhite from "./ginoc_logo_transparent.png";
import EditPreviousPayrollPage from "./EditPreviousPayrollPage";
import PaySchedule from "./PaySchedule";
import EditDeductionsPage from "./EditDeductionsPage";
import AddDeductionsPage from "./AddDeductionsPage";
import RunPayrollPage from "./RunPayrollPage";
import ViewPayrollPage from "./ViewPayroll";
import EditLastPayroll from "./EditLastPayroll";
import EditRecordPage from "./EditRecordPage";
import RunNewPay from "./RunNewPay";
import UserProfilePage from "./UserProfilePage";
import AddBankInfoPage from "./AddBankInfoPage";
import EditBankInfoPage from "./EditBankInfoPage";
import InactiveEmployees from "./InactiveEmployees";
import RecentPayroll from "./RecentPayroll";
import PayList from "./PayList";
import TaxInformationPage from "./TaxInformationPage";
import TaxRatesPage from "./TaxRatesPage";
import EditTaxPage from "./EditTaxPage";
import MissingTaxInfoPage from "./MissingTaxInfoPage";
import TaxComparisonPage from "./TaxComparisonPage";
import FixTaxInfoPage from "./FixTaxInfoPage";
import Detected from "./Detected";
import TaxStatusPage from "./TaxStatusPage";
import PastPayroll from "./PastPayroll";
import AccountingPage from "./AccountingPage";
import BalancePage from "./BalancePage";
import LeaveTracker from "./LeaveTracker";
import BusinessLeaveRequests from "./BusinessLeaveRequests";
import DepartmentsPage from "./DepartmentsPage";
import EditFederalTaxPage from "./EditFederalTaxPage";
import EditCityTaxPage from "./EditCityTaxPage";
import EditProfilePage from "./EditProfilePage";
import AddUserPage from "./AddUserPage";
import FaqsPage from "./FaqsPage";
import SupportRequestPage from "./SupportRequestPage";
import CheckWriter from "./CheckWriter";
import RetirementSetup from "./RetirementSetup";
import BenefitsSetup from "./BenefitsSetup";
import BenefitsPage from "./BenefitsPage";
import BenefitsDental from "./BenefitsDental";
import BenefitsVision from "./BenefitsVision";
import TransactionsPage from "./TransactionsPage";
import ProfitLossPage from "./ProfitLossPage";
import BreakdownPage from "./BreakdownPage";
import MobileMenu from "./MobileMenu"; // ✅ Add this at the top
import AllBusinessesPage from "./AllBusinessesPage";
import InvoicePage from "./InvoicePage";
import VendorPage from "./VendorPage";
import ProductPage from "./ProductPage";
import InvoiceReferencePage from "./InvoiceReferencePage";
import CreateInvoicePage from "./CreateInvoicePage";
import PayrollReconciliationPage from "./PayrollReconciliationPage";
import CashInPage from "./CashInPage";
import CashReconciliationPage from "./CashReconciliationPage";
import ReconciliationDetailPage from "./ReconciliationDetailPage";
import RequiredCashReconciliationPage from "./RequiredCashReconciliationPage";
import EstimateReferencePage from "./EstimateReferencePage";
import CreateEstimatePage from "./CreateEstimatePage";
import BankingPage from "./BankingPage";
import InvoicesHubPage from "./InvoicesHubPage";
import AdminRunPayroll from "./AdminRunPayroll";
import UIWagesPage from "./UIWagesPage";
import AverageCogsPage from "./AverageCogsPage";
import FixedCostsPage from "./FixedCostsPage";
import IntegrationsPage from "./IntegrationsPage";
import SubwayDataPage from "./SubwayDataPage";
import SubwayCashInPage from "./SubwayCashInPage";
import SubwayRequiredCashPage from "./SubwaRequiredCashPage";
import SubwayEmployeesPage from "./SubwayEmployeesPage";
import PayrollSyncPage from "./PayrollSyncPage";
import SubwaySpotCheckPage from "./SubwaySpotCheck";
import ScrollToTop from "./ScrollToTop";
import SubwayPaidouts from "./SubwayPaidouts";
import SubwaySpotCheckAllPage from "./SubwaySpotCheckAllPage";






const Dashboard = () => {
    const [businesses, setBusinesses] = useState([]); // List of businesses
    const [selectedBusiness, setSelectedBusiness] = useState(null); // Currently selected business
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const hamburgerRef = useRef(null);

    const [theme, setTheme] = useState(() => localStorage.getItem("pw-theme") || "light");
useEffect(() => {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem("pw-theme", theme);
}, [theme]);



    

    const navigate = useNavigate();


    const fetchBusinesses = async () => {
        try {
            const { data } = await api.get("/businesses-lite");
            setBusinesses(data);
            if (data.length > 0) {
                setSelectedBusiness(data[0]); // Default to the first business
            }
        } catch (error) {
            alert("Failed to fetch businesses.");
        }
    };

    const location = useLocation();
    
    useEffect(() => {
        fetchBusinesses();
    }, []);


    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
        };
      
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);



      // REPLACE your effect that reads businessId from URL with this:
        useEffect(() => {
        // Matches "/dashboard/business/123" or "/business/123"
        const match = location.pathname.match(/\/(?:dashboard\/)?business\/(\d+)/);
        if (match) {
            const businessIdFromURL = parseInt(match[1], 10);
            const matched = businesses.find((b) => b.id === businessIdFromURL);
            if (matched && (!selectedBusiness || selectedBusiness.id !== matched.id)) {
            setSelectedBusiness(matched);
            }
        }
        }, [location.pathname, businesses, selectedBusiness]);


    //   useEffect(() => {
    //     const match = location.pathname.match(/\/dashboard\/business\/(\d+)/);
    //     if (match) {
    //         const businessIdFromURL = parseInt(match[1], 10);
    //         const matched = businesses.find((b) => b.id === businessIdFromURL);
    //         if (matched && (!selectedBusiness || selectedBusiness.id !== matched.id)) {
    //         setSelectedBusiness(matched);
    //         }
    //     }
    //     }, [location.pathname, businesses, selectedBusiness]);

    const handleLogout = async () => {
        try {
            // Invalidate the refresh token and clear the cookie on the server
            await api.post("/logout");
    
            // Remove any stored access tokens (if you're storing it anywhere)
            localStorage.removeItem("accessToken");
            sessionStorage.removeItem("accessToken");
    
            // Remove Authorization header from future requests
            delete api.defaults.headers.common["Authorization"];
    
            // Redirect to public page
            navigate("/home");
    
            // Force full reload to clear any React state and cached user data
            window.location.reload();
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };
    

const isBusinessSelectDisabled =
  location.pathname.includes("/subway-data") ||
  location.pathname.includes("/subway-employees/") ||
  location.pathname.includes("/subway-cash-in") ||
  location.pathname.includes("/payroll-sync") ||
  location.pathname.includes("/subway-spotcheck") ||
  location.pathname.includes("/subway-paidouts") ||
  location.pathname.includes("/edit-employee") ||
  location.pathname.includes("/add-employee") ||
  location.pathname.includes("/add-deductions") ||
  location.pathname.includes("/edit-deductions");
    
// REMOVE your existing handleBusinessChange and use this:
const handleBusinessChange = (e) => {
  const value = e.target.value;

  if (value === "add-business") {
    navigate("/dashboard/add-business");
    return;
  }

  const newId = parseInt(value, 10);
  const selected = businesses.find((b) => b.id === newId);
  setSelectedBusiness(selected);

  // Preserve current path (employees, payroll, etc.) while swapping the business id
  const { pathname, search, hash } = location;

  // Matches both "/dashboard/business/123/..." and "/business/123/..."
  const dashMatch = pathname.match(/^\/dashboard\/business\/\d+(\/.*)?$/);
  const bareMatch = pathname.match(/^\/business\/\d+(\/.*)?$/);

  if (dashMatch) {
    const suffix = dashMatch[1] || "";
    navigate(`/dashboard/business/${newId}${suffix}${search}${hash}`);
  } else if (bareMatch) {
    const suffix = bareMatch[1] || "";
    navigate(`/business/${newId}${suffix}${search}${hash}`);
  } else {
    // Fallback if current page isn't business-scoped
    // navigate(`/dashboard/business/${newId}`);
    navigate(`${pathname}${search}${hash}`);
  }
};


    // Handle business selection change
    // const handleBusinessChange = (e) => {
    //     const businessId = e.target.value;

    //     if (businessId === "add-business") {
    //         // Navigate to Add Business
    //         navigate("/dashboard/add-business");
    //         return;
    //     }

    //     const selected = businesses.find((business) => business.id === parseInt(businessId));
    //     setSelectedBusiness(selected);

    //     // Redirect to the selected business's details page
    //     if (selected) {
    //         navigate(`/dashboard/business/${selected.id}`);
    //     }
    // };

    return (
        <div className="dashboard-page">
            {/* Static Header */}
           
            {isMobile && isMobileMenuOpen && (
                
                <MobileMenu
                
                    selectedBusiness={selectedBusiness}
                    onLogout={handleLogout}
                    onClose={() => setIsMobileMenuOpen(false)}
                    hamburgerRef={hamburgerRef}
                />
                )}


            



      

            {!isMobile && <BusinessNav selectedBusiness={selectedBusiness} />}


            {/* Layout with Navigation and Dynamic Content */}
            <div className="dashboard-body">

            <div className="main-logo">
                <img
  src="/logo512.png"
  alt="Payweek Logo"
  className="dashboard-logo logo--light"
/>


 <img
  src="/logo512.png"
  alt="Payweek Logo"
  className="dashboard-logo logo--dark"
/> 

                   </div>
                {/* Navigation Panel */}

                {/* <BusinessNav selectedBusiness={selectedBusiness} /> */}
                


    
                {/* Main Content */}
                <main className="dashboard-content">

                <ScrollToTop />

 <header className="dashboard-header">

             {isMobile && (
              <>
                    <img
  src="/logo512.png"
  alt="Payweek Logo"
  className="dashboard-logo logo--light"
/>
<img
  src="/logo512.png"
  alt="Payweek Logo"
  className="dashboard-logo logo--dark"
/>
</>
                )}
                        
                {/* Business selector (Listbox) */}
<div className="business-selector">
  {(() => {
    const options = [
  ...businesses.map((b) => ({ id: String(b.id), name: b.name })),
  { id: "add-business", name: "+ Add Business +", action: true },
];

const currentValue = selectedBusiness?.id ? String(selectedBusiness.id) : "add-business";
const currentLabel =
  options.find(o => o.id === currentValue)?.name || "+ Add Business +";

    return (
        <Listbox
  value={currentValue}
  disabled={isBusinessSelectDisabled}
  onChange={(val) => {
    if (isBusinessSelectDisabled) return;

    handleBusinessChange({ target: { value: val } });
  }}
>
        <div className="lb-root">
          <Listbox.Button
  className={`lb-button ${isBusinessSelectDisabled ? "disabled" : ""}`}
  aria-label="Choose business"
>
            <span className={`lb-button-text ${currentValue === "default" ? "placeholder" : ""}`}>
              {currentLabel}
            </span>
            <span className="lb-caret">▾</span>
          </Listbox.Button>

          <Listbox.Options className="lb-options">
            {options.map((opt) => (
              <Listbox.Option
                key={opt.id}
                value={opt.id}
                disabled={!!opt.disabled}
                className={({ active, disabled }) =>
                  [
                    "lb-option",
                    active ? "active" : "",
                    disabled ? "disabled" : "",
                    opt.action ? "action" : "",
                  ].join(" ")
                }
              >
                {({ selected }) => (
                  <Fragment>
                    <span className="lb-label">{opt.name}</span>
                    {selected && <span className="lb-check">✓</span>}
                  </Fragment>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </div>
      </Listbox>
    );
  })()}
</div>

                <button
                    ref={hamburgerRef}
                    className="hamburger-menu"
                    onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                    >
                    ☰
                    </button>
                    

                    {(!isMobile || !isMobileMenuOpen) && (
  <button
    className="home-dashboard"
    onClick={() => navigate("/dashboard/business/user/profile")}
    aria-label="User profile"
  >
    <HiMiniUserCircle />
  </button>
)}

                    
                
            </header>

                    <Routes>
                        
                        <Route index element={<Navigate to="business/user/profile" replace />} />

                        <Route
                            path="business/user/profile"
                            element={<UserProfilePage theme={theme} setTheme={setTheme} />}
                        />

                        

                        
                        <Route path="add-business" element={<AddBusiness onBusinessAdded={fetchBusinesses} />} />

                        <Route 
  path="business/:id" 
  element={<BusinessPage selectedBusiness={selectedBusiness} />} 
/>

                        
                        <Route
                            path="business/add-employee"
                            element={<AddEmployeePage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/employees"
                            element={<EmployeesPage key={selectedBusiness?.id} selectedBusiness={selectedBusiness} />}
                        />



                        <Route
                            path="business/:id/start-payroll"
                            element={<StartPayrollPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/add-previous-payroll"
                            element={<AddPreviousPayrollPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/edit-previous-payroll"
                            element={<EditPreviousPayrollPage selectedBusiness={selectedBusiness} />}
                        />



                        <Route
                        path="edit-employee"
                        element={<EditEmployeePage selectedBusiness={selectedBusiness} />}
                        />
                        <Route 
                        path="add-deductions" 
                        element={<AddDeductionsPage selectedBusiness={selectedBusiness} />} 
                        />

                        <Route 
                        path="edit-deductions" 
                        element={<EditDeductionsPage selectedBusiness={selectedBusiness}  />} 
                        />



                        <Route
                            path="business/:id/set-pay-period"
                            element={<PaySchedule selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/process-payroll"
                            element={<RunPayrollPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/admin-payroll"
                            element={<AdminRunPayroll selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/viewpayroll"
                            element={<ViewPayrollPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/editlastpayroll"
                            element={<EditLastPayroll selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/edit-record/:recordid"
                            element={<EditRecordPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/run-new-pay"
                            element={<RunNewPay selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                            path="business/:id/UI-wages"
                            element={<UIWagesPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/add-bank-info"
                            element={<AddBankInfoPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/edit-bank-info"
                            element={<EditBankInfoPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/inactive"
                            element={<InactiveEmployees selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/pay-page"
                            element={<RecentPayroll selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/list-page"
                            element={<PayList selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/tax-information"
                            element={<TaxInformationPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/user/profile"
                            element={<UserProfilePage />}
                        />
                        <Route
                            path="business/:id/tax-rates"
                            element={<TaxRatesPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/:taxId"
                            element={<EditTaxPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/missing-tax"
                            element={<MissingTaxInfoPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/comparison"
                            element={<TaxComparisonPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                            path="business/:id/fix"
                            element={<FixTaxInfoPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                        path="business/:id/detect"
                        element={<Detected selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                        path="business/:id/tax-status"
                        element={<TaxStatusPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                        path="business/:id/past-payroll"
                        element={<PastPayroll selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                        path="business/:id/accounting"
                        element={<AccountingPage selectedBusiness={selectedBusiness} />}
                        />
                        <Route
                        path="business/:id/balance"
                        element={<BalancePage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/leave-tracker"
                        element={<LeaveTracker selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/leave-requests"
                        element={<BusinessLeaveRequests selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/departments"
                        element={<DepartmentsPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/fed-tax"
                        element={<EditFederalTaxPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/city-tax/:cityId"
                        element={<EditCityTaxPage selectedBusiness={selectedBusiness} />}
                        /> 

                        <Route
                        path="business/:id/check-write"
                        element={<CheckWriter selectedBusiness={selectedBusiness} />}
                        /> 

                        <Route
                        path="business/:id/retirement-setup"
                        element={<RetirementSetup selectedBusiness={selectedBusiness} />}
                        /> 

                        <Route
                        path="business/:id/benefits-setup"
                        element={<BenefitsSetup selectedBusiness={selectedBusiness} />}
                        /> 

                        <Route
                        path="business/:id/benefits-dental"
                        element={<BenefitsDental selectedBusiness={selectedBusiness} />}
                        /> 

                        <Route
                        path="business/:id/benefits-vision"
                        element={<BenefitsVision selectedBusiness={selectedBusiness} />}
                        /> 

                        <Route
                        path="business/:id/benefits-view"
                        element={<BenefitsPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/transactions-view"
                        element={<TransactionsPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/profit-loss"
                        element={<ProfitLossPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/breakdown"
                        element={<BreakdownPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/invoice"
                        element={<InvoicePage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/vendors"
                        element={<VendorPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/products"
                        element={<ProductPage selectedBusiness={selectedBusiness} />}
                        />


                        <Route
                        path="business/:id/invoicing"
                        element={<InvoicesHubPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/invoiceref"
                        element={<InvoiceReferencePage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/invoicecreate"
                        element={<CreateInvoicePage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/invoiceest"
                        element={<EstimateReferencePage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/estimatecreate"
                        element={<CreateEstimatePage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/payroll-reconciliation"
                        element={<PayrollReconciliationPage selectedBusiness={selectedBusiness} />}
                        />

                        {/* <Route
                        path="business/:id/cash-in"
                        element={<CashInPage selectedBusiness={selectedBusiness} />}
                        /> */}

                        <Route
                            path="business/:id/cash-in"
                            element={<CashInPage key={selectedBusiness?.id} selectedBusiness={selectedBusiness} />}
                            />

                            <Route
                            path="business/:businessId/subway-required"
                            element={<SubwayRequiredCashPage  selectedBusiness={selectedBusiness} />}
                            />


                        <Route
                        path="business/:id/cash-recon"
                        element={<CashReconciliationPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="/business/:businessId/reconciliation/:categoryId"
                        element={<ReconciliationDetailPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="/business/:businessId/required-cash"
                        element={<RequiredCashReconciliationPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/banking"
                        element={<BankingPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/average-cogs"
                        element={<AverageCogsPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/fixed-costs"
                        element={<FixedCostsPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/integration"
                        element={<IntegrationsPage selectedBusiness={selectedBusiness} />}
                        />

                        <Route
                        path="business/:id/subway-data"
                        element={<SubwayDataPage  />}
                        />

                        <Route path="subway-employees/:businessId/:storeNumber" element={<SubwayEmployeesPage />} />

                        <Route
                        path="business/:id/subway-cash-in"
                        element={<SubwayCashInPage  />}
                        />

                        <Route
                        path="business/:id/payroll-sync"
                        element={<PayrollSyncPage selectedBusiness={selectedBusiness} />}
                        />


                        <Route
                        path="business/:id/subway-spotcheck"
                        element={<SubwaySpotCheckPage  />}
                        />

                        <Route
  path="business/:id/subway-paidouts"
  element={<SubwayPaidouts />}
/>

                      <Route
                        path="subway-spotcheck-all"
                        element={<SubwaySpotCheckAllPage />}
                      />

                        <Route
                        path="user/edit"
                        element={<EditProfilePage/>}
                        /> 

                        <Route
                        path="add/user"
                        element={<AddUserPage/>}
                        /> 

                        <Route
                        path="faqs"
                        element={<FaqsPage/>}
                        /> 


                        <Route
                        path="support"
                        element={<SupportRequestPage />}
                        /> 

                        <Route
                        path="billing"
                        element={<AllBusinessesPage />}
                        /> 

                        

                        

                    
                    </Routes>
                </main>
            </div>
        </div>
    );
};


export default Dashboard;




